import React from "react";
import { useTranslation } from "react-i18next";
import { Panel } from "components/bootstrap";
import { Icon } from "components/common";
import { StyledPanel } from "../../CommonStyledComponents";
const InputProfileHelpPanel = () => {
  const { t } = useTranslation("enterprise_forwarder");
  return /* @__PURE__ */ React.createElement(StyledPanel, { bsStyle: "info" }, /* @__PURE__ */ React.createElement(Panel.Heading, null, /* @__PURE__ */ React.createElement(Panel.Title, { componentClass: "h3" }, /* @__PURE__ */ React.createElement(Icon, { name: "info" }), " ", t("input_profile_help_panel.heading"))), /* @__PURE__ */ React.createElement(Panel.Body, null, /* @__PURE__ */ React.createElement("p", null, t("input_profile_help_panel.description"))));
};
export default InputProfileHelpPanel;
